import { render } from "./ShipMovement.vue?vue&type=template&id=4121ac8f&scoped=true"
import script from "./ShipMovement.vue?vue&type=script&lang=js"
export * from "./ShipMovement.vue?vue&type=script&lang=js"

import "./ShipMovement.vue?vue&type=style&index=0&id=4121ac8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4121ac8f"]])

export default __exports__